// Api actions
export const API_CALL = 'API_CALL';
export const API_CALL_SUCCESS = 'API_CALL_SUCCESS';
export const API_CALL_ERROR = 'API_CALL_ERROR';
export const API_CALL_VALIDATION_ERROR = 'API_CALL_VALIDATION_ERROR';

// Form actions
export const FORM_INIT = 'FORM_INIT';
export const FORM_UPDATE = 'FORM_UPDATE';
export const FORM_RESET = 'FORM_RESET';

// Flash Messages
export const FLASH_MESSAGE_SET = 'FLASH_MESSAGE_SET';
export const FLASH_MESSAGE_CLEAR = 'FLASH_MESSAGE_CLEAR';

// Process Queue
export const PROCESS_QUEUE = 'PROCESS_QUEUE';
export const PROCESS_QUEUE_UPDATE = 'PROCESS_QUEUE_UPDATE';
export const PROCESS_QUEUE_ERROR = 'PROCESS_QUEUE_ERROR';
export const PROCESS_QUEUE_CLEAR_ERROR = 'PROCESS_QUEUE_CLEAR_ERROR';

export const HORSE_LIGHTBOX_OPEN = 'HORSE_LIGHTBOX_OPEN';
export const HORSE_LIGHTBOX_CLOSE = 'HORSE_LIGHTBOX_CLOSE';
export const HORSE_LIGHTBOX_SET_INDEX = 'HORSE_LIGHTBOX_SET_INDEX';

export const HORSE_SET_EDIT_MODE = 'HORSE_SET_EDIT_MODE';
export const UPDATE_SET_EDIT_MODE = 'UPDATE_SET_EDIT_MODE';

export const SET_SUGGESTION_SEARCH_STATE = 'SET_SUGGESTION_SEARCH_STATE';
